import * as stylex from '@stylexjs/stylex';
import { colors } from '@seeqdev/qomponents/colors.stylex';

export const formulaStyles = stylex.create({
  parameterSearchResults: { maxHeight: '425px' },
  typeBadge: {
    backgroundColor: colors.formulaTypeBadgeBackground,
    color: colors.textOnLight,
    padding: '2px 5px',
    fontSize: '0.8rem',
    borderRadius: '5px',
  },
  optionalParameter: { fontStyle: 'italic' },
  functionResult: {
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: colors.separator,
    color: colors.bodyText,
    backgroundColor: { 'default': null, ':hover': colors.legacyToolsRowHover, ':focus': colors.legacyToolsRowFocus },
    outlineWidth: { 'default': null, ':hover': 0, ':focus': 0 },
    cursor: 'pointer',
    paddingTop: '0.625rem',
    paddingBottom: '0.625rem',
    paddingLeft: '0.3125rem',
  },
  parameterTable: {
    color: colors.bodyText,
    position: 'relative',
    borderCollapse: 'collapse',
    marginBottom: '0.1875rem',
    overflowX: 'hidden',
  },
  parameterNameHeading: {
    position: 'sticky',
    top: 0,
    zIndex: 100,
    borderWidth: 0,
    backgroundColor: colors.background,
    padding: '2px 3px',
    verticalAlign: 'top',
    minWidth: '47px',
  },
  parameterItemHeading: {
    position: 'sticky',
    top: 0,
    zIndex: 100,
    borderWidth: 0,
    backgroundColor: colors.background,
    padding: '2px 3px',
    verticalAlign: 'top',
    maxWidth: '370px',
  },
  parameterActionsHeading: {
    position: 'sticky',
    top: 0,
    zIndex: 100,
    borderWidth: 0,
    backgroundColor: colors.background,
    padding: '2px 3px',
    verticalAlign: 'top',
    width: '1%',
  },
  parameterRow: { backgroundColor: { 'default': null, ':nth-of-type(odd)': colors.tableRowAlternate } },
  parameterCell: { position: 'relative', borderWidth: 0, padding: '2px 3px', verticalAlign: 'top' },
  emptyParameterCell: {
    position: 'relative',
    borderWidth: 0,
    padding: '2px 3px',
    verticalAlign: 'top',
    flex: '1 1 auto',
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'center',
  },
  parameterIdentifierCell: {
    position: 'relative',
    borderWidth: 0,
    padding: '2px 3px',
    verticalAlign: 'middle',
    display: 'flex',
    flexDirection: 'row',
  },
  parameterActionsCell: {
    position: 'relative',
    borderWidth: 0,
    padding: '2px 3px',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
  },
  parameterItemWidth: (width: number) => ({ minWidth: width }),
  parameterAction: { marginLeft: '10px' },
  compactParameterAction: { marginLeft: '5px' },
  parameterIdentifier: { fontWeight: 'bold' },
  parameterText: { textAlign: 'left' },
  redactedParameter: { color: colors.borderInvalid },
  errorMessage: { fontFamily: 'var(--font-family-sans-serif)', fontSize: '0.8125rem' },
  searchMatch: { color: colors.legacyToolsPrimary },
  errorAlert: { display: 'flex', flexDirection: 'row', padding: '5px' },
  helpHeaderSpacer: { flex: '1 1 auto', overflow: 'hidden' },
  variableToolbarSpacer: { flex: '1 1 auto', overflow: 'hidden' },
  errorContent: { flex: '1 1 auto', overflow: 'hidden' },
  exampleContent: { flex: '1 1 auto', overflow: 'hidden' },
  parameterIdentifierInput: { flex: '1 1 auto', overflow: 'hidden' },
  parameterItemContent: { flex: '1 1 auto', overflow: 'hidden' },
  parameterListInput: { flex: '1 1 auto', overflow: 'hidden' },
  errorLocation: { whiteSpace: 'pre-wrap' },
  helpTrigger: {
    cursor: 'pointer',
    color: colors.legacyToolsPrimary,
    whiteSpace: 'nowrap',
    paddingLeft: '0.5rem',
    textDecoration: 'underline',
  },
  parameterModal: { display: 'flex', flexDirection: 'column', marginTop: '0.3125rem' },
  variableToolbar: { display: 'flex', flexDirection: 'row', marginBottom: '0.125rem' },
  variableActions: { display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center' },
  unitPopover: { padding: 0, borderWidth: 0 },
  unitSelector: { width: '100%' },
  helpIcon: { cursor: 'pointer' },
  exampleRow: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between' },
  insertExample: { cursor: 'pointer', paddingLeft: '5px', paddingTop: '5px', paddingRight: '5px' },
  resultType: { color: colors.mutedForeground },
  functionLink: { textDecoration: 'underline', color: colors.legacyToolsLink },
  emptyResults: { textAlign: 'center', fontStyle: 'italic' },
  helpHeader: { display: 'flex', flexDirection: 'row' },
  hideHelp: {
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    color: colors.legacyToolsPrimary,
    whiteSpace: 'nowrap',
    marginTop: '0.4375rem',
    marginRight: '0.4375rem',
    alignItems: 'flex-end',
    textDecoration: 'underline',
  },
  moveHelp: { marginTop: '10px', marginRight: '10px', cursor: 'pointer' },
  helpContents: {
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: '0.625rem',
    paddingRight: '0.5rem',
    paddingBottom: '3.125rem',
    paddingLeft: '0.5rem',
  },
  documentation: { height: '100%', marginTop: '0.625rem', overflowY: 'auto' },
  pageContent: { paddingRight: '0.3125rem' },
  relatedList: { paddingLeft: '1.25rem' },
  documentationHeader: {
    display: 'flex',
    flexDirection: 'row',
    flex: 'none',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerIcon: { paddingRight: '10px' },
  headerAction: { paddingRight: '10px', cursor: 'pointer', color: colors.legacyToolsPrimary },
  headerSearch: { flexGrow: 1 },
  pageTitle: { marginTop: 0 },
  parameterHeading: { marginBottom: '0.3125rem' },
  parameterHeader: { display: 'flex', flexDirection: 'row', alignItems: 'baseline', justifyContent: 'space-between' },
  parameterName: { marginTop: '0.1875rem', marginBottom: 0 },
  typeLabel: { paddingRight: '0.3125rem', paddingLeft: '0.3125rem' },
  parameterDetails: { paddingLeft: '0.625rem' },
  optionalNote: { paddingLeft: '0.125rem' },
  signatureRow: { display: 'flex', flexDirection: 'row', marginTop: '0.3125rem', justifyContent: 'space-between' },
  signatureHeading: { paddingRight: '0.3125rem' },
  section: { marginBottom: '0.625rem' },
  lastSection: { marginBottom: '0.9375rem' },
  relatedItem: { marginBottom: '0.3125rem' },
  lastRelatedItem: { marginBottom: '0.625rem' },
  helpRoot: { display: 'flex', flexDirection: 'column', height: '100%' },
  helpInline: { maxWidth: '400px', minWidth: '400px' },
  editor: { display: 'flex', flexDirection: 'column', flex: '1 1 auto', overflow: 'hidden', marginTop: 0 },
  editorContent: { flex: '1 1 auto', overflow: 'hidden', height: '100%' },
  editableBorder: { borderWidth: 1, borderStyle: 'solid', borderColor: colors.sampleInputBorder },
  requiredBorder: { borderColor: colors.borderInvalid, boxShadow: 'none' },
  showHelp: { display: 'flex', flexDirection: 'row' },
  parameterNameField: { marginBottom: '15px' },
});
